export const SET_POST_PROJECT_INSURED_ERROR = 'SET_POST_PROJECT_INSURED_ERROR';
export const SET_PROJECT_INSUREDS_LIST_ERROR = 'SET_PROJECT_INSUREDS_LIST_ERROR';
export const SET_PROJECT_INSUREDS_LIST = 'SET_PROJECT_INSUREDS_LIST';
export const SET_FETCHING_PROJECT_INSUREDS = 'SET_FETCHING_PROJECT_INSUREDS';
export const SET_SHOW_PROJECT_INSUREDS_MODAL = 'SET_SHOW_PROJECT_INSUREDS_MODAL';
export const SET_PROJECT_INSUREDS_FAVORITE = 'SET_PROJECT_INSUREDS_FAVORITE';
export const SET_PROJECT_INSUREDS_FAVORITE_FETCHING = 'SET_PROJECT_INSUREDS_FAVORITE_FETCHING';
export const SET_PROJECT_MAPPINGS = 'SET_PROJECT_MAPPINGS';
